export default __webpack_public_path__ + "static/bg_cta-2f183e957cd2bc679feb2ad13c7e1212.png";